export default __webpack_public_path__ + "static/media/spa.f44034cb.jpeg";